"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const sidebar_style_1 = __importDefault(require("../sidebar.style"));
const button_1 = require("components/atoms/button");
const material_1 = require("@mui/material");
const SubMenuItem = ({ subMenuItem, icon, onClick }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ onClick: () => onClick(subMenuItem), style: sidebar_style_1.default.subMenuItem(subMenuItem.selected, theme.palette.mode), className: theme.palette.mode === 'light' ? 'hover-light' : 'hover-dark' }, { children: [icon && (0, jsx_runtime_1.jsx)(button_1.Icon, { src: icon, style: sidebar_style_1.default.subMenuIcon }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'subtitle2', style: sidebar_style_1.default.subMenuTitle, color: subMenuItem.selected ? '#ff6702' : undefined }, { children: subMenuItem.title }))] })));
};
exports.default = SubMenuItem;
